
<template>
    <vxe-modal :title="dialogtitle"  :width="dialogWidth" className="showdialogClassName" destroy-on-close
        v-model="dialogJsonFormsVisible" show-zoom resize  draggable>
        <div class="nofull-tool-result">
            <ZyJsonForms :validationMode="validationMode" ref="myzyJsonforms">
                <template #options>
                    <v-btn @click="btnpbcDebug" class="btn-action" :loading="isdebug" block small color="primary">{{ btnText
                    }}
                    </v-btn>
                </template>
            </ZyJsonForms>
        </div>

    </vxe-modal>
</template>

<script>
import ZyJsonForms from "@/components/jsonForms/ZyJsonForms"
import userDocApi from "@/assets/js/userDocApi";
import apiAxios from "@/config/apiAxios";
export default {
    name: "dialogJsonForms",
    components: { ZyJsonForms },
    props: {
        btnText: {
            type: String,
            default: "开启智囊"
        },
        btnTextLoading: {
            type: String,
            default: "智囊分析中..."
        }

    },
    data() {
        return {
            dialogtitle: "",
            dialogWidth: "",
            dialogJsonFormsVisible: false,
            validationMode: "ValidateAndHide",
            isdebug: false,
            debugfinish:false,
            pbcid: "", // 执行pbcfid
            pbcapi: "api000145", // 执行规则表 api
            pbcParamsPath: "usys/products/release/cache",// 执行参数上传路径

        }
    },
    methods: {
        btnpbcDebug() {
            // 下载pbc工具箱json文件信息
            let that = this;
            this.isdebug = true;
            this.debugfinish = false;
            // 先上传表单文件内容，收数据
            let fromFileName = `${$func.getUUID_resource()}.json`
            // 分开处理 schemadata 数据，将文件 和 表单数据分开
            // 文件数据
            let fileData = [];

            let formData = {};
            let schemadata=this.$refs.myzyJsonforms.getFomData()
            Object.keys(schemadata).forEach(_k => {
                let _val = schemadata[_k];
                if (!_val)
                    return;
                /*ndisk开通的为云盘文件*/
                if (_val.toString().startsWith("ndisk:")) {
                    fileData.push({ name: _k, val: JSON.parse(_val.slice(6)) });
                    formData[_k] = JSON.parse(_val.slice(6));
                } else {

                    formData[_k] = _val;
                }

            })
            console.log(formData)
            let formFileData = new File([JSON.stringify(formData)], fromFileName)
            let label = `${this.dialogtitle}_form收集数据`
            let formfileParam = {
                content: formFileData,
                label: label,
                name: fromFileName
            }

            userDocApi.createFile(this.pbcParamsPath, fromFileName, formfileParam, _r1 => {
                if (_r1.code == 200) {
                    // 构建资源清单
                    let upjson = {
                        id: $func.getUUID_resource(),
                        name: '',
                        desc: '用户调试pbc上传文件执行物料清单',
                        token: sessionStorage.getItem('USER_TOKEN_VAL') || localStorage.getItem('USER_TOKEN_VAL'),//用户token
                        category: "params",
                        "exteralRefs": [""],
                        resources: [
                
                            {
                                name: "inputParam",
                                type: "formfields",
                                uri: _r1.data.fid,// 数据收集，formdata fid
                            },
                            {
                                name: 'server',
                                type: "pbc",
                                uri: this.pbcid, // sbom文件fid,个人目录usys/widgets/ 里面找
                            }
                        ]

                    }
                    fileData.forEach(_k => {
                        let _val = _k.val;
                        // 单个文件
                        upjson.resources.push({ name: _k.name, type: "formfile", uri: _val[0].fid })
                    })
                    // 处理fid 
                    upjson.artifactId = `${this.dialogtitle}_执行参数`
                    let fileName = `${upjson.id}.json`;
                    let FileData = new File([JSON.stringify(upjson)], fileName);
                    let fileParam = {
                        content: FileData,
                        label: upjson.name,
                        name: fileName
                    }
                    console.log('_r');

                    userDocApi.createFile(this.pbcParamsPath, fileName, fileParam, _r => {
                        if (_r.code == 200) {
                            // 执行规则表
                            let fid = _r.data.fid;
                            let eventsource = `${window.eventkey}_${this.pbcid}`
                            let _param = { fid: fid, ruleApiNumber:this.pbcapi, token: sessionStorage.getItem('USER_TOKEN_VAL') || localStorage.getItem('USER_TOKEN_VAL'), sseKey: window.sseKey, eventsource: eventsource }
                            apiAxios.apmASyncPost(this.pbcapi, _param, {}, res => {
                                this.isdebug = false;
                                if (res.code == 200) {
                                    this.$notify({ type: 'success', message: '产品执行中，大概花5-10分钟，您可以关闭当前界面，进行其他操作，执行结果将通知您' })
                                } else {
                                   
                                    this.$notify({ type: 'danger', message: '执行失败！' })
                                }

                            })

                        } else {
                            this.$notify({ type: 'danger', message: '上传参数资源清单文件失败！' })
                        }
                        // console.log(_r);
                    })
                } else {
                    this.$notify({ type: 'danger', message: '上传表单文件失败！' })
                }

            })
        },
    },
    mounted() { },
    created() {
        let that = this;
        this.$EventBus.$on("opendialogJsonForms", (e) => {
            let _params = e._params;
            if (_params) {
                this.dialogtitle = _params.dialogtitle;
            }
            if (_params.pbcid) {
                this.pbcid = _params.pbcid
            }
            if (_params.pbcapi) {
                this.pbcapi = _params.pbcapi
            }
            if (_params.pbcParamsPath) {
                this.pbcParamsPath = _params.pbcParamsPath
            }
            this.dialogWidth = "60%";

            this.dialogJsonFormsVisible = true;
            that.$nextTick(() => {
                if(that.$refs.myzyJsonforms){
                that.$refs.myzyJsonforms.InitJsonForms(_params.detail.schema, _params.detail.uiSchema, _params.detail.data);
                }
            })
        })
    }
}
</script>

<style lang="less" scoped>
.nofull-tool-result {
    // height: calc(100% - 10px);
}
</style>

